"use client";

import React from "react";
import { Separator } from "@/components/ui/separator";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurPhilosophy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const philosophyPoints = [{
    title: "Geist & Klarheit",
    description: "Psychologische Tiefe und intellektuelle Klarheit bilden das Fundament für nachhaltige Veränderung."
  }, {
    title: "Körper & Bewegung",
    description: "Durch Tai Chi und bewusste Bewegung verankern wir Resilienz direkt in der körperlichen Erfahrung."
  }, {
    title: "Natur & Erdung",
    description: "Die unberührte Kraft des Soonwaldes dient als Spiegel und Kraftquelle für regenerative Prozesse."
  }, {
    title: "Struktur & Ordnung",
    description: "Klare organisatorische Rahmenbedingungen schaffen den Raum, in dem Synergien entfaltet werden."
  }];
  return;
}